import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import OrganisationSelector from '../../organisation/OrganisationSelector';

const SelectorView = ({loading}) => (
  <div className="card mb-3">
    {loading && <div className="loading-overlay"/>}
    <div className="card-header">
      <div className="card-title">
        <Translate value="globalDashboard.myOrganisations"/>
      </div>
    </div>
    <OrganisationSelector showAllOrganisationsOnClick/>
  </div>
);

SelectorView.propTypes = {
  loading: PropTypes.bool
};

export default SelectorView;
